import URLS from 'constants/urls';
import { transformKeysToCamelCase, transformKeysToSnakeCase } from 'helpers/core';
import { reportError } from 'helpers/error-logging';
import { httpClient } from 'helpers/http';
import {
  VenueUserFeedbackRequest,
  VenueUserFeedbackResponse,
} from '@classpass/protobuf-definitions/lib/web/models/partners/reservation';

export function getReservationFeedbackAlreadyReported(feedback) {
  return {
    disruptiveUserAlreadyReported: !!feedback?.disruptiveUserReported,
    trialAbuseAlreadyReported: !!feedback?.trialAbuseReported,
  };
}

export async function submitReservationFeedback({ reservationId, feedback, description }) {
  try {
    const payload = VenueUserFeedbackRequest.toJSON(
      transformKeysToSnakeCase({
        reservationId,
        feedback: feedback ?? [],
        description: description ?? '',
      })
    );
    const response = await httpClient.post(URLS.schedule.submitReservationFeedback, payload);
    const data = transformKeysToCamelCase(VenueUserFeedbackResponse.fromJSON(response?.data ?? {}));
    return { isPaid: data.isPaid ?? false };
  } catch (error) {
    reportError(error);
    throw error;
  }
}
